iScreenWizard.factory('WizardFeedbackSessie', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('wizardfeedbacksessie', params).then(function (response) {
                var wizardfeedbacksessies = response.data;
                resolve(wizardfeedbacksessies);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('wizardfeedbacksessie/'+id).then(function (response) {
                var wizardfeedbacksessie = response.data;
                resolve(wizardfeedbacksessie);
            }, reject);
        });
    };

    return data;
});